import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import "../../Subscription.css";

const PriceCalculator = ({
	value,
	error,
	helperText,
	expectedPrice,
	onChange,
	onBlur,
}) => {
	const [price, setPrice] = useState(Math.round(value));

	useEffect(() => {
		setPrice(Math.round(value));
	}, [value]);

	return (
		<div className="subscription-section">
			<div className="price-calculator-container">
				<div className="price-calculator-input-wrapper">
					<TextField
						type="number"
						label="Number of Hosts"
						variant="outlined"
						name="calculateHosts"
						className="price-calculator-input"
						value={price}
						error={error}
						helperText={helperText}
						onChange={onChange}
						onBlur={onBlur}
						InputProps={{
							inputProps: { min: 3 }
						}}
					/>
				</div>

				<div className="price-calculator-result">
					<div className="price-calculator-result-label">
						Estimated Monthly Cost
					</div>
					<h3 className="price-calculator-result-value">
						${expectedPrice}
					</h3>
				</div>
			</div>
		</div>
	);
};

export default PriceCalculator;
